import React, { useState, useContext } from "react"
import {
    Grid,
    TextField,
    Autocomplete,
    CircularProgress
} from "@mui/material"
import { useSelector } from "react-redux"
import TLServiceComponent from "../../../../../contexts/TLServiceComponent"

const SearchUGCForm = ({ translate, ugc, addRight }) => {
    const [founded, setFounded] = useState([])
    const [selected, setSelected] = useState(null)
    const [loading, setLoading] = useState(false)
    const token = useSelector((state) => state.userData.token)
    const tlService = useContext(TLServiceComponent)

    const handleInputChange = async (_, value, reason) => {
        if (reason === 'input' && value.length > 1) {
            setLoading(true)
            let res = [[], []]
            try {
                switch (ugc) {
                    case 0:
                        res[0] = await tlService.getFilteredUsers(token, {}, { email: `%${value}%` })
                        res[1] = await tlService.getFilteredUsers(token, {}, { user_name: `%${value}%` })
                        break
                    case 1:
                        res[0] = await tlService.getFilteredGroups(token, {}, { name: `%${value}%` })
                        break
                    case 2:
                        res[0] = await tlService.getFilteredCompanies(token, {}, { name: `%${value}%` })
                        break
                    default:
                        return
                }

                let listResult = []
                if (res[0]?.data) listResult = [...res[0].data]
                if (res[1]?.data) {
                    const filtered = res[1].data.filter(
                        value1 => listResult.findIndex(value2 => value2.id === value1.id) === -1
                    )
                    listResult = listResult.concat(filtered)
                }

                setFounded(listResult)
            } catch (e) {
                setFounded([])
            }
            setLoading(false)
        } else if (value.length <= 1) {
            setFounded([])
        }
    }

    const handleSelectUser = (_, newValue) => {
        if (newValue && newValue.id) {
            const newRight = [
                newValue.id,
                ugc === 0 ? newValue.user_name : newValue.name
            ]
            setSelected(newValue)
            addRight(newRight)
        } else {
            setSelected(null)
            addRight(false)
        }
    }

    return (
        <Grid container spacing={2} alignItems="center" justifyContent='center' padding={1}>
            <Grid item xs={12} md={9}>
                <Autocomplete
                    fullWidth
                    size="small"
                    options={founded}
                    loading={loading}
                    value={selected}
                    onChange={handleSelectUser}
                    onInputChange={handleInputChange}
                    getOptionLabel={(option) =>
                        typeof option === 'string' ? option : (ugc === 0 ? option.user_name : option.name || "")
                    }
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    noOptionsText={translate("admin_texttype_ugc-search-no-options")}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translate("admin_texttype_ugc-search-select")}
                            variant="outlined"
                            InputLabelProps={{ style: { fontSize: 15}, shrink: true }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            }}
                        />
                    )}
                />
            </Grid>
        </Grid>
    )
}

export default SearchUGCForm
